import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrl: './agents.component.scss'
})
export class AgentsComponent {
  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  statut: any = '';
  isDisabled: boolean = false;
  hasError = false;
  errorMessage = '';
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalContent1') modalContent1: TemplateRef<any>;
  detailsItems: any
  membreItems:any =[];
  cooperativeItems:any =[];
  filteredCooperatives: any[] = [];
  selectedCooperative: string = '';
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private paramService: ParameterService,
  ) {
    this.getAgents();
   }

  getCooperative() {
    //this.isLoading = true;
    //this.hasError = false;

    this.paramService.getCooperative().subscribe(
      (response: any) => {
       // this.isLoading = false;
        this.cooperativeItems = response.data;

        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }


  openModal(item:any) {
    this.detailsItems = item
    console.log("this.detailsItems",this.detailsItems);

    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }








  getAgents() {
    this.isLoading = true;
    this.hasError = false;

    this.paramService.getAgents().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();
        this.getCooperative()
        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        //console.log("une erreu est survenu", error);
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = 'Impossible de charger les données';
      }
    )
  }
  filterAgents() {
    if (!this.selectedCooperative) {
      this.filteredtems = this.items;
    } else {
      this.filteredtems = this.items.filter(member =>
        member.cooperative?.id === +this.selectedCooperative
      );
    }
    this.first = 0; // Réinitialisation de la pagination après le filtrage
    this.updatePaginated();
  }
  searchAgents() {
    if (!this.searchTerm) {
      this.filteredtems = this.items; // Si le champ est vide, on remet la liste complète
    } else {
      this.filteredtems = this.items.filter(member =>
        `${member.nom} ${member.prenom}`.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }

    this.first = 0; // Réinitialisation de la pagination
    this.updatePaginated();
  }
}
